import { useMemo } from "react"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { mergeMacroCategoryOptions, normalizeMacroCategoryList } from "authoring/routes/macro/lib/macro-category-utils"
import { MacroCategorySelector } from "./macro-category-selector"

export function MacroCategoriesInner({ categories = [], editMode = true }) {
    const [selectedCategories, setSelectedCategories] = useBoundValue("categories")
    const options = useMemo(
        () => mergeMacroCategoryOptions(categories, selectedCategories ?? []),
        [categories, selectedCategories]
    )

    return (
        <MacroCategorySelector
            categories={options}
            selectedCategories={selectedCategories ?? []}
            onChange={handleChange}
            disabled={!editMode}
        />
    )

    function handleChange(nextCategories) {
        setSelectedCategories(normalizeMacroCategoryList(nextCategories))
    }
}
